/* global Swiper */

const swiperBreakpoints = {
	576: {
		slidesPerView: 1.4,
		spaceBetween: 16,
	},
	768: {
		slidesPerView: 2,
		spaceBetween: 16,
	},
	1024: {
		slidesPerView: 4.5,
		spaceBetween: 16,
	},
};
const loopAdditionalSlides = 10;

/**
 * Returns numeric Swiper param or fallback.
 *
 * @param {unknown} value   Swiper param value.
 * @param {number}  fallback Fallback numeric value.
 *
 * @return {number} Numeric param value.
 */
function getNumericParam( value, fallback ) {

	return typeof value === 'number' && Number.isFinite( value ) ? value : fallback;

}

const maxSlidesPerView = Math.max(
	getNumericParam( 1.05, 1 ),
	...Object.values( swiperBreakpoints ).map( ( breakpointParams ) =>
		getNumericParam( breakpointParams.slidesPerView, 1 )
	)
);
const maxSlidesPerGroup = Math.max(
	getNumericParam( 1, 1 ),
	...Object.values( swiperBreakpoints ).map( ( breakpointParams ) =>
		getNumericParam( breakpointParams.slidesPerGroup, 1 )
	)
);
const minSlidesForLoop = Math.max(
	10,
	Math.ceil( maxSlidesPerView ) + Math.ceil( maxSlidesPerGroup ) + loopAdditionalSlides
);

document.querySelectorAll( '.b-testimonials-slider' ).forEach( ( block ) => {

	const slider = block.querySelector( '.b-testimonials-slider__slider.swiper' );
	const isReverseDirection = block.dataset.sliderDirection === 'reverse';
	const isManualDirection = block.dataset.sliderDirection === 'manual';

	if ( isReverseDirection ) {

		block.classList.add( 'is-direction-reverse' );

	} else {

		block.classList.remove( 'is-direction-reverse' );

	}

	if ( ! slider ) {

		return;

	}

	if ( slider.classList.contains( 'swiper-initialized' ) ) {

		return;

	}

	const wrapper = slider.querySelector( '.b-testimonials-slider__grid.swiper-wrapper' );
	let slidesCount = 0;
	if ( wrapper ) {

		const originalSlides = Array.from( wrapper.children ).filter( ( node ) => node.nodeType === 1 );

		originalSlides.forEach( ( slide ) => {

			slide.classList.add( 'swiper-slide' );

		} );

		if ( originalSlides.length > 0 && originalSlides.length < minSlidesForLoop ) {

			let cloneIndex = 0;
			while ( wrapper.children.length < minSlidesForLoop ) {

				const sourceSlide = originalSlides[ cloneIndex % originalSlides.length ];
				const clone = sourceSlide.cloneNode( true );
				clone.classList.add( 'swiper-slide' );
				wrapper.appendChild( clone );
				cloneIndex++;

			}

		}

		slidesCount = wrapper.children.length;

	}

	const prevButton = block.querySelector( '.b-testimonials-slider__nav-button--prev' );
	const nextButton = block.querySelector( '.b-testimonials-slider__nav-button--next' );

	const swiperConfig = {
		loop: true,
		loopAddBlankSlides: false,
		watchOverflow: false,
		allowTouchMove: false,
		simulateTouch: false,
		speed: 8000,
		freeMode: {
			enabled: true,
			sticky: false,
			momentum: false,
			momentumBounce: false,
		},
		autoplay: {
			delay: 0,
			stopOnLastSlide: false,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
			reverseDirection: false,
			waitForTransition: true,
		},
		slidesPerView: 1.05,
		spaceBetween: 12,
		loopAdditionalSlides,
		breakpoints: swiperBreakpoints,
		observer: true,
		observeParents: true,
	};

	if ( isManualDirection ) {

		swiperConfig.allowTouchMove = false;
		swiperConfig.simulateTouch = false;
		swiperConfig.speed = 500;
		swiperConfig.freeMode.enabled = false;
		swiperConfig.autoplay = false;
		swiperConfig.centeredSlides = true;
		swiperConfig.loopAdditionalSlides = loopAdditionalSlides;
		swiperConfig.loopedSlides = Math.max( slidesCount, minSlidesForLoop );
		swiperConfig.slidesPerGroup = 1;

		if ( prevButton && nextButton ) {

			swiperConfig.navigation = {
				prevEl: prevButton,
				nextEl: nextButton,
			};

		}

	}

	const swiper = new Swiper( slider, swiperConfig );

	if ( !isManualDirection && swiper?.autoplay ) {

		/**
		 * Keeps autoplay active after user interactions.
		 *
		 * @return {void}
		 */
		function ensureAutoplay() {

			if ( swiper.destroyed ) {

				return;

			}

			if ( swiper.autoplay.paused ) {

				swiper.autoplay.resume();

			}

			if ( ! swiper.autoplay.running ) {

				swiper.autoplay.start();

			}

		}

		swiper.on( 'touchEnd', ensureAutoplay );
		swiper.on( 'tap', ensureAutoplay );
		swiper.on( 'click', ensureAutoplay );

		const autoplayWatchdog = setInterval( () => {

			if ( swiper.destroyed ) {

				clearInterval( autoplayWatchdog );
				return;

			}

			ensureAutoplay();

		}, 1500 );

	}

} );
